
import { defineComponent, ref, reactive, toRefs, onMounted } from 'vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
export default defineComponent({
  setup(props, context) {
    const route = useRoute()
    const theme = route.query.theme || 'light'
    function gotobrowser() {
      let url: any = route.query.url
      url = decodeURIComponent(url) + '&zspecifyfield=pdf'
      window.open(`gw://openurl?param=${url}`)
    }

    return {
      gotobrowser,
      theme
    }
  }
})
